import { createContext } from 'react';

import type { UIFeatures } from '../types';

/**
 * Union of allowed types in `UIFeatures`.
 * Please **DO NOT** add any other type without starting a discussion in {@link https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxMzMxMDc3NiJ9/new Mordern Clients}. Also make sure to tag the authors below 👇
 * @author Brian Stone <brianstone@microsoft.com>
 * @author Rafael Tavares <rafaelro@microsoft.com>
 * @author Richard Tagger <ritagger@microsoft.com>
 */
type UIFeaturesAllowedTypes = boolean;

type ValidateUIFeaturesNestedObject<T> = T extends {
  [K in keyof T]?: T[K] extends infer U ? (U extends UIFeaturesAllowedTypes ? U : never) : never;
}
  ? T
  : never;

type ValidateUIFeatures<T> = T extends { [K in keyof T]?: ValidateUIFeaturesNestedObject<T[K]> } ? T : never;

const UIFeatureContext = createContext<ValidateUIFeatures<UIFeatures> | undefined>(undefined);

/**
 * @deprecated `@ms/yammer-web-ui-features` is a monolithic package which adds bloat from all feature access settings
 * to a single bootstrap API call (FeatureAccessSettingsClients) and JS assets. DO NOT add new code to this package.
 * Your team is responsible for migrating fields and code out of this package as you move your features to Relay, where
 * your feature should request the necessary `viewerCanXX` fields in its own colocated fragment. Note that we may also
 * need to design a new scalable permissions-check solution for features which require additional logic to check access.
 */
export default UIFeatureContext;
